import {
  type BusinessProfileFields,
  type PlaceBankTransferInput,
  placeBankTransferInputSchema,
} from '@repo/api-contracts';

export interface BankTransferFormValues extends Omit<BusinessProfileFields, 'contactName'> {
  readonly orderId: string;
  readonly depositorName: string;
  readonly requestTaxInvoice: boolean;
  readonly saveToProfile: boolean;
  readonly contactName: string;
}
export type BankTransferFormErrors = Partial<Record<keyof BankTransferFormValues, string>>;

const LABELS: Record<string, string> = {
  orderId: '주문',
  depositorName: '입금자명',
  businessNumber: '사업자등록번호',
  companyName: '상호',
  representativeName: '대표자',
  address: '사업장 주소',
  businessType: '업태',
  businessItem: '종목',
  invoiceEmail: '세금계산서 받을 이메일',
  contactName: '담당자명',
};

/** 계약 스키마로 검증하고 화면 입력 칸에 맞는 한글 안내로 바꾼다. */
export const parseBankTransferForm = (
  values: BankTransferFormValues,
):
  | { readonly ok: true; readonly input: PlaceBankTransferInput }
  | { readonly ok: false; readonly errors: BankTransferFormErrors } => {
  const { orderId, depositorName, requestTaxInvoice, saveToProfile, ...fields } = values;
  const result = placeBankTransferInputSchema.safeParse({
    orderId,
    depositorName,
    taxInvoice: requestTaxInvoice
      ? { ...fields, contactName: fields.contactName.trim() || null, saveToProfile }
      : null,
  });
  if (result.success) return { ok: true, input: result.data };
  const errors: BankTransferFormErrors = {};
  for (const issue of result.error.issues) {
    const field = issue.path.at(-1) as keyof BankTransferFormValues;
    if (errors[field]) continue;
    const label = LABELS[field] ?? '입력값';
    errors[field] =
      field === 'businessNumber'
        ? '사업자등록번호는 숫자 10자리여야 합니다.'
        : field === 'invoiceEmail'
          ? '세금계산서 받을 이메일을 올바르게 입력해 주세요.'
          : issue.code === 'too_big'
            ? `${label}은(는) ${issue.maximum}자 이내로 입력해 주세요.`
            : `${label}을(를) 올바르게 입력해 주세요.`;
  }
  return { ok: false, errors };
};
